import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2>Contact Us</h2>
        <div className="contact-grid">
          <div className="contact-info">
            <p>
              <FontAwesomeIcon icon={faPhone} /> +91 7890067005
            </p>
            <p>
              <FontAwesomeIcon icon={faEnvelope} /> support@topupconnect.in
            </p>
            <p>
              <FontAwesomeIcon icon={faClock} /> Open: 9:00 AM - 9:00 PM (7 days
              a week)
            </p>
          </div>
          <div className="contact-form">
            <form>
              <input type="text" placeholder="Your Name" />
              <input type="email" placeholder="Your Email" />
              <input type="text" placeholder="Phone Number" />
              <textarea placeholder="Your Message"></textarea>
              <button type="submit" className="btn">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
